<mat-dialog-content class="modal-header"><h2 mat-dialog-title>SOLICITAR EDICIÓN DE PROGRAMA PASST</h2></mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
  
    <mat-dialog-content class="modal-body">
      <div class="content">
        <div class="form-horizontal">
            <div class="form-group">
                <label class="col-md-2 control-label">Año:</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Año</mat-label>
                    <input matInput type="text" placeholder="año" [(ngModel)]="model.anio" maxlength="40"
                      name="anio"
                      disabled
                    >
                    <!-- [readonly]="data.enableEdit"  -->
                  </mat-form-field>                
                </div>
                <label class="col-md-2 control-label">Sede:</label>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Sede</mat-label>
                    <input matInput type="text" placeholder="sede" [(ngModel)]="model.sede"  maxlength="40"
                      name="sede"
                      disabled
                    >
                  </mat-form-field>            
                </div>  
            </div>   
            <div class="form-group">     
                <label class="col-md-2 control-label">Mes (*):</label>
            <div class="col-md-4">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Mes</mat-label>
                    <mat-select matSelect [(ngModel)]="model.mesSelected"
                    name="mesSelected"
                    #mesSelected="ngModel"  required>
                        <mat-option *ngFor="let mes of meses; index as i;" [value]='mes.value'>{{mes.viewValue}}</mat-option>
                      </mat-select>
                  </mat-form-field>
            </div>     
          </div>
        </div>  
      </div>  
      <div class="content">
        <div class="form-horizontal">
          <div class="form-group">
            <label class="col-md-2 control-label">Motivo (*):</label>
            <div class="col-md-10">
              <mat-form-field class="example-full-width" appearance="outline" hideRequiredMarker>
                <mat-label>Motivo</mat-label>
                <textarea
                  matInput
                  placeholder="Motivo"
                  rows="5" [(ngModel)]="model.motivo"
                  
                  name="comentarios" maxlength="2000" required
                ></textarea>
                <!-- 
                  [disabled]="modelPersona.idEstado === 2" -->
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end" class="modal-actions">
      <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-button ><mat-icon>send</mat-icon> Enviar</button> 
      <!-- [disabled]="!EsValido()" -->
      <!-- [mat-dialog-close]="data" -->
      <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" [disabled]="modelForm.invalid" (click)="guardar()">Submit</button> -->
      <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Salir</button>
    </mat-dialog-actions>
    
    </form>